<template>
  <div>
    <b-card no-body>
      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->

          <!-- Search -->
          <b-col
              cols="12"
              md="8"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Nhập tên, mã, mobile, vị trí, email để tìm kiếm ..."
              />
            </div>
          </b-col>

          <b-col
              class="d-flex align-items-center justify-content-end mb-1 mb-md-0" cols="12"
              md="4">
            <b-button
                variant="primary"
                @click="New()">
              Thêm nhân viên
            </b-button>
          </b-col>

        </b-row>

      </div>
      <b-table :fields="fields" :items="items" responsive="sm">
        <template #cell(name)="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>

        <template #cell(actions)="row">
          <div class="d-flex">
            <b-button v-if="row.item.IS_AD != 1" v-b-tooltip.hover.top="'Đổi mật khẩu!'" class="mr-05 btn-icon" size="sm"
                      variant="info" @click="ChangePas(row.item, row.index, $event.target)">
              <feather-icon icon="LockIcon"/>
            </b-button>
            <b-button v-if="row.item.IS_AD == 1" v-b-tooltip.hover.top="'Đổi mật khẩu!'"
                      class="mr-05 btn-icon"
                      href="https://account.activedirectory.windowsazure.com/ChangePassword.aspx" size="sm" target="blank" variant="info">
              <feather-icon icon="LockIcon"/>
            </b-button>
            <b-button v-b-tooltip.hover.top="'Phân quyền!'" class="mr-05 btn-icon" size="sm"
                      variant="info" @click="Permission(row.item, row.index, $event.target)">
              <feather-icon icon="UserCheckIcon"/>
            </b-button>
            <b-button v-b-tooltip.hover.top="'Cập nhật thông tin!'" class="mr-05 btn-icon" size="sm"
                      variant="info" @click="Edit(row.item, row.index, $event.target)">
              <feather-icon icon="EditIcon"/>
            </b-button>
            <b-button v-b-tooltip.hover.top="'Xoá người dùng!'" class="mr-05 btn-icon" size="sm"
                      variant="danger" @click="Delete(row.item, row.index, $event.target)">
              <feather-icon icon="DeleteIcon"/>
            </b-button>
            <b-button v-if="row.item.LOGIN_FAIL && row.item.LOGIN_FAIL >= 5"
                      v-b-tooltip.hover.top="'Mở khóa tài khoản!'" class="btn-icon" size="sm"
                      variant="danger" @click="handleUnlockAccount(row.item)">
              <feather-icon icon="UnlockIcon"/>
            </b-button>
          </div>

        </template>

      </b-table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
        <b-col class="d-flex align-items-center justify-content-start mb-1 mb-md-0" cols="12"
               md="6">
          <label>Số bản ghi</label>
          <v-select
              v-model="perPage"
              :clearable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
              style="min-width:60px"
          />
          <label>trong 1 trang</label>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-end mb-1 mb-md-0" cols="12"
               md="6">
          <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows"/>
        </b-col>
      </b-row>
    </b-card>
    <b-modal id="modal-edit" :title="modal_title" size="lg" @ok="handleOk">
      <validation-observer ref="simpleRules">
        <b-row>
          <b-col cols="3">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group label="Tên đăng nhập">
                <b-form-input v-model="currentItem.ID" :readonly="readonly()" :state="errors.length > 0 ? false:null"
                              placeholder="Tên đăng nhập"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="3">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group label="Mã nhân viên">
                <b-form-input v-model="currentItem.MA_NV" :state="errors.length > 0 ? false:null"
                              placeholder="Mã nhân viên"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group label="Họ & tên">
                <b-form-input v-model="currentItem.FULL_NAME" :state="errors.length > 0 ? false:null"
                              placeholder="Họ tên đầy đủ"/>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <validation-provider #default="{ errors }" rules="regex:^([0-9]+)$|required">
              <b-form-group label="Số điện thoại">
                <b-form-input v-model="currentItem.MOBILE" :state="errors.length > 0 ? false:null"
                              placeholder="Số điện thoại"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider #default="{ errors }" rules="email|required">
              <b-form-group label="Email">
                <b-form-input v-model="currentItem.EMAIL" :state="errors.length > 0 ? false:null" placeholder="Email"/>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Giới tính">
              <v-select v-model="gender" :clearable="false" :options="genders" label="title"/>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Chức danh">
              <v-select v-model="member_type" :clearable="false" :options="member_types" label="NAME"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label="User level">
              <v-select v-model="userLevelId" :clearable="false" :options="optionsUserLevels" label="NAME"/>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Kho">
              <v-select v-model="storeId" :clearable="false" :options="Stores" label="NAME"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12 d-flex">
            <b-form-group>
              <b-form-checkbox v-model="currentItem.STATUS" class="mr-2" switch>
                Trạng thái tài khoản
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="currentItem.IS_AD" switch>
                IS_AD
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-pass" scrollable title="Đổi mật khẩu" @ok="handChangePass">
      <validation-observer ref="simpleRules">
        <validation-provider #default="{ errors }" rules="required|password" vid="confirm">
          <b-form-group label="Mật khẩu mới">
            <b-form-input v-model="changepass.new" :state="errors.length > 0 ? false:null" placeholder="Mật khẩu mới"
                          type="password"/>
            <div class="error-txt">
              <!-- <small v-if="errors.length > 0">Mật khẩu không hợp lệ</small> -->
              <small v-if="errors.length > 0">Mật khẩu phải chứa ít nhất 8 ký tự trong đó có ít nhất 1 ký tự hoa, 1 ký
                tự thường, 1 chữ số, 1 ký tự đặt biệt</small>
            </div>
          </b-form-group>
        </validation-provider>
        <validation-provider #default="{ errors }" rules="required|confirmed:confirm">
          <b-form-group label="Nhập lại">
            <b-form-input v-model="changepass.retype" :state="errors.length > 0 ? false:null" placeholder="Nhập lại"
                          type="password"/>
            <div class="error-txt">
              <small v-if="errors.length > 0">Nhập lại mật khẩu không đúng</small>
            </div>
          </b-form-group>
        </validation-provider>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-permission" body-class="p-0" scrollable title="Gán nhóm quyền cho người dùng"
             @ok="handPermission">
      <b-table :fields="perFields" :items="permisItems" responsive="sm">
        <template #cell(name)="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>
        <template #cell(C)="row">
          <b-form-checkbox v-model="row.item.C"/>
        </template>
        <template #cell(R)="row">
          <b-form-checkbox v-model="row.item.R"/>
        </template>
        <template #cell(U)="row">
          <b-form-checkbox v-model="row.item.U"/>
        </template>
        <template #cell(D)="row">
          <b-form-checkbox v-model="row.item.D"/>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {confirmed, email, required} from '@validations'
import vSelect from 'vue-select'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'

extend('password', (value) => {
  const specialChars = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*\(\)-_+=:;',?~<>{}]).{8,}$/
  return specialChars.test(value);
});

export default {
  components: {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, vSelect,
    FeatherIcon, BModal, BFormGroup, BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    this.fetchUser();
    useJwt.get('member_types').then(response => {
      this.member_types = response.data.result;
    }).catch(error => {
      console.log(error);
    })
    this.fetchStores();
  },
  watch: {
    perPage: function (n, o) {
      this.fetchUser()
    },
    searchQuery: function (n, o) {
      this.fetchUser()
    },
    currentPage: function (n, o) {
      this.fetchUser()
    }
  },
  methods: {
    fetchPermission: function () {
      this.permisItems = [];
      useJwt.get(`userGroup/${this.currentItem.ID}`, {})
          .then(response => {
            this.permisItems = response.data.result;
            this.permisItems.forEach(function (i, v) {
              i.C = (i.C == 1) ? true : false;
            })
          })
          .catch(error => {
            console.log(error);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Lỗi lấy danh sách quyền theo nhóm ' + this.currentItem.ROLE_NAME,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    },
    fetchUser: function () {
      useJwt.get('organization', {
        params: {
          search: this.searchQuery,
          page: this.currentPage,
          pageSize: this.perPage
        },
      })
          .then(response => {
            this.items = response.data.result;
            this.totalRows = response.data.result.length;
          })
          .catch(error => {
            console.log(error);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Lỗi lấy danh sách nhóm',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    },
    Permission(item, index, button) {
      this.currentItem = item;
      this.fetchPermission();
      this.$bvModal.show('modal-permission')
    },
    ChangePas(item, index, button) {
      this.currentItem = item;
      this.$bvModal.show('modal-pass')
    },
    Edit(item, index, button) {
      this.currentItem = {...item};
      this.gender = this.genders.find(e => e.id === item.GENDER_ID)
      this.member_type = this.member_types.find(e => e.ID === item.MEMBER_TYPE_ID)
      this.userLevelId = this.optionsUserLevels.find(e => e.ID == item.USER_LEVEL)
      this.storeId = this.Stores.find(e => e.ID == item.STORE_ID)
      this.currentItem.STATUS = item.STATUS_ID == 1 ? true : false;
      this.currentItem.IS_AD = item.IS_AD && item.IS_AD == 1 ? true : false;
      this.modal_title = "Cập nhật người dùng"
      this.$bvModal.show('modal-edit')
    },
    New() {
      this.currentItem = {}
      this.currentItem.IS_AD = true;
      this.modal_title = "Thêm mới người dùng"
      this.$bvModal.show('modal-edit')
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm('Vui lòng xác nhận bạn muốn xoá người dùng: ' + item.FULL_NAME, {
        title: 'Please Confirm',
        size: 'sm',
      })
      if (res) {
        useJwt.delete(`organization/${this.currentItem.ID}`, {})
            .then(response => {
              this.fetchUser();
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Xoá người dùng thành công!', icon: 'CheckSquareIcon', variant: 'info'}
              })
            })
            .catch(error => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Lỗi xoá người dùng', icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      }
    },
    async handChangePass(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then(success => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        return;
      }
      useJwt.post('changepass-force', {
        id: this.currentItem.ID, "old_password": "", "password": this.changepass.new
      })
          .then(response => {
            this.$bvModal.hide('modal-pass')
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Cập nhật thành công!', icon: 'CheckSquareIcon', variant: 'success'}
            })
            // setTimeout(function(){
            //   localStorage.clear();
            //   router.push({name:'auth-login'});
            // },3000);
          })
          .catch(error => {
            console.log(error.response);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Lỗi cập nhật người dùng${(error.response && error.response.data && error.response.data.message ? ` [${error.response.data.message}]` : '')}`,
                icon: 'AlertTriangleIcon',
                variant: 'danger'
              }
            })
          })
    },
    handPermission(bvModalEvt) {
      bvModalEvt.preventDefault()
      var groups = [];
      this.permisItems.filter(i => i.C).forEach(e => groups.push(e.ID));
      useJwt.put(`userGroup/${this.currentItem.ID}`, {
        id: this.currentItem.ID,
        groups: groups
      })
          .then(response => {
            this.fetchPermission();
            this.$bvModal.hide('modal-permission')
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Cập nhật thành công!', icon: 'CheckSquareIcon', variant: 'info'}
            })
          })
          .catch(error => {
            console.log(error);
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Lỗi cập nhật quyền cho nhóm', icon: 'AlertTriangleIcon', variant: 'danger'}
            })
          })
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then(success => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        return;
      }
      if (this.modal_title == "Cập nhật người dùng") {
        useJwt.put(`organization`, {
          id: this.currentItem.ID,
          ma_nv: this.currentItem.MA_NV,
          full_name: this.currentItem.FULL_NAME,
          mobile: this.currentItem.MOBILE,
          email: this.currentItem.EMAIL,
          gender: this.gender.e,
          member_type_id: this.member_type.ID,
          status: this.currentItem.STATUS ? 1 : 0,
          is_ad: this.currentItem.IS_AD ? 1 : 0,
          user_level: this.userLevelId ? this.userLevelId.ID : 0,
          store_id: this.storeId ? this.storeId.ID : 0
        })
            .then(response => {
              this.fetchUser();
              this.$bvModal.hide('modal-edit')
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Cập nhật thành công!', icon: 'CheckSquareIcon', variant: 'info'}
              })
            })
            .catch(error => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Lỗi cập nhật người dùng', icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      } else {
        useJwt.post('organization', {
          id: this.currentItem.ID,
          ma_nv: this.currentItem.MA_NV,
          full_name: this.currentItem.FULL_NAME,
          mobile: this.currentItem.MOBILE,
          email: this.currentItem.EMAIL,
          gender: this.gender.e,
          member_type_id: this.member_type.ID,
          status: this.currentItem.STATUS ? 1 : 0,
          is_ad: this.currentItem.IS_AD ? 1 : 0
        })
            .then(response => {
              this.fetchUser();
              this.$bvModal.hide('modal-edit')
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Thêm mới thành công!', icon: 'CheckSquareIcon', variant: 'info'}
              })
            })
            .catch(error => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Lỗi thêm mới người dùng', icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      }
    },
    readonly() {
      return !(this.modal_title == "Thêm mới người dùng");
    },
    async handleUnlockAccount(item) {
      var res = await this.$bvModal.msgBoxConfirm('Bạn có chắc muốn mở khóa tài khoản này không?', {
        title: 'Please Confirm',
        size: 'sm'
      })
      if (res) {
        useJwt.put(`organization_unlock/${item.ID}`, {})
            .then(response => {
              this.fetchUser();
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Mở khóa thành công!', icon: 'CheckSquareIcon', variant: 'info'}
              })
            })
            .catch(error => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Lỗi mở khóa tài khoản', icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      }
    },
    async fetchStores() {
      useJwt.post("getMasterData/B2C_Store", {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 1000
      })
          .then((response) => {
            this.Stores = response.data.result.map((item) => {
              return {
                ID: item.Id,
                NAME: item.Name,
              };
            });
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Có lỗi trong quá trình lấy dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
            })
          });
    },
  },
  data() {
    return {
      items: [],
      permisItems: [],
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      searchQuery: "",
      gender: {},
      member_type: {},
      currentItem: {},
      changepass: {},
      modal_title: "Thêm mới người dùng",
      genders: [{"id": 1, "title": "Nam", "e": 1}, {"id": 2, "title": "Nữ", "e": 2}],
      member_types: [],
      storeId: {},
      Stores: [],
      userLevelId: {},
      optionsUserLevels: [
        {
          ID: 1,
          NAME: 'Toàn quốc'
        },
        {
          ID: 2,
          NAME: 'Cấp miền'
        }
      ],
      fields: [
        {
          key: 'ID',
          sortable: true,
          label: 'ID'
        },
        {
          key: 'MA_NV',
          sortable: true,
          label: 'Mã nhân viên'
        },
        {
          key: 'FULL_NAME',
          sortable: true,
          label: 'Họ & tên'
        },
        {
          key: 'MOBILE',
          label: 'Số điện thoại',
          sortable: true,
        },
        {
          key: 'EMAIL',
          label: 'Email',
          sortable: true,
        },
        {key: 'actions', label: 'Actions'}
      ],
      perFields: [
        {
          key: 'ROLE_NAME',
          sortable: true,
          label: 'Chức năng'
        },
        {
          key: 'C',
          sortable: true,
          label: 'Thuộc nhóm'
        },
      ],
      required,
      email,
      confirmed
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.error-txt small {
  color: red;
}
</style>
